import { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../../../../hook/useAppSelector";
import { useAppDispatch } from "../../../../../hook/useAppDispatch";

import {
  setIsShellModalVisible,
  setModalType,
} from "../../../../../store/slice/health-monitor/modal";
import { setShellVersions } from "../../../../../store/slice/health-monitor/device-details";

import { GeoDivision } from "../../../../../enum/GeoDivision";

import { getPathFromURL } from "../../../../../util/url";

const ShellModal: React.FC = () => {
  const deviceDetails = useAppSelector(
    (state) => state.deviceDetails.deviceDetails
  );
  const [selectedVersion, setSelectedVersion] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const shellVersions = useAppSelector(
    (state) => state.deviceDetails.shellVersions
  );
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleVersionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedVersion(event.target.value);
  };

  const handleLevelChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedLevel(event.target.value);
  };

  const handleShellUpdateAndRestart = (restartAfterUpdate: boolean) => {
    dispatch(
      setShellVersions({
        deviceUserID: getPathFromURL(4),
        shellVersion: Number(selectedVersion),
        restartPostUpdate: restartAfterUpdate,
        level: Number(selectedLevel),
      })
    );
  };

  return (
    <>
      {createPortal(
        <div className="overlay_modal">
          <div className="modal_content shell">
            <div>{t("healthMonitor.deviceDetails.shellModal.title")}</div>
            <div className="info">
              <div className="shell_versions">
                <label htmlFor="current">
                  {t("healthMonitor.deviceDetails.shellModal.currentVersion")}
                </label>
                <p>{deviceDetails?.shell}</p>
              </div>
              <div className="shell_versions">
                <label htmlFor="dropdown">
                  {t("healthMonitor.deviceDetails.shellModal.newVersion")}
                </label>
                <select
                  className="dropdown_select"
                  value={selectedVersion}
                  onChange={handleVersionChange}
                >
                  <option>
                    {t("healthMonitor.deviceDetails.shellModal.selectVersion")}
                  </option>
                  {shellVersions?.map((singleShellVersion) => (
                    <option
                      key={`${singleShellVersion.id}_${singleShellVersion.name}`}
                      value={singleShellVersion.id}
                    >
                      {singleShellVersion.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="shell_versions">
                <label htmlFor="dropdown">
                  {t("healthMonitor.deviceDetails.shellModal.updateLevel")}
                </label>
                <select
                  className="dropdown_select"
                  value={selectedLevel}
                  onChange={handleLevelChange}
                >
                  <option>
                    {t("healthMonitor.deviceDetails.shellModal.level.title")}
                  </option>
                  <option value={GeoDivision.LOCATION}>
                    {t("healthMonitor.deviceDetails.shellModal.level.location")}
                  </option>
                  <option value={GeoDivision.GROUP}>
                    {t("healthMonitor.deviceDetails.shellModal.level.group")}
                  </option>
                </select>
              </div>
            </div>
            <div className="buttons">
              <button
                className="update"
                onClick={() => {
                  handleShellUpdateAndRestart(false);
                  dispatch(setIsShellModalVisible(false));
                  dispatch(setModalType(null));
                }}
              >
                {t("healthMonitor.deviceDetails.shellModal.update")}
              </button>
              <button
                className="update"
                onClick={() => {
                  handleShellUpdateAndRestart(true);
                  dispatch(setIsShellModalVisible(false));
                  dispatch(setModalType(null));
                }}
              >
                {t("healthMonitor.deviceDetails.shellModal.updateAndRestart")}
              </button>
              <button
                className="cancel"
                onClick={() => {
                  dispatch(setIsShellModalVisible(false));
                  dispatch(setModalType(null));
                }}
              >
                {t("healthMonitor.deviceDetails.shellModal.cancel")}
              </button>
            </div>
          </div>
        </div>,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        document.getElementById("root_overlay")!
      )}
    </>
  );
};

export default ShellModal;
